import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import { INotice } from "../../model/notice/Notice";

export interface TPortalHomePresenter extends TLoadingAwarePresenter {
  noticeList: INotice[];
}

export interface IPortalHomePresenter
  extends TPortalHomePresenter,
    TPresentable {
  loadNoticeList(noticeList: INotice[]): void;
}

const defaultState: TPortalHomePresenter = {
  noticeList: []
};

const PortalHomePresenter = withStore<
  IPortalHomePresenter,
  TPortalHomePresenter
>(({ application, store, loader, translate }): IPortalHomePresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<TPortalHomePresenter>();

  const loadNoticeList = (noticeList: INotice[]) => {
    _store.update({
      noticeList
    });
  };

  return {
    ...state,
    store: _store,
    loader,
    application: _application,
    translate,
    loadNoticeList
  };
}, defaultState);

export default PortalHomePresenter;
